export default __webpack_public_path__ + "static/media/cafe.487b196f.jpg";